import { useGlobal } from "@/context/global"
import { useServer } from "@/context/server"

/**
 * 计算 skill 广场操作（安装/卸载/更新）的目标工作空间目录。
 * 与首页「+」新建对话的目标目录保持一致（home-controller 的 newSessionProject 逻辑）：
 * 最近打开的项目 → 第一个项目。
 *
 * 注意：不依赖 useLayout()，因为 skill 广场页面挂在 /scheduled-tasks 路由下，
 * 该路由不在 Layout context provider 的作用域内，调用 useLayout() 会抛
 * "Layout context must be used within a context provider" 错误。
 */
export function useSkillMarketDirectory() {
  const server = useServer()
  const global = useGlobal()

  return () => {
    const conn = server.current
    if (!conn) return undefined
    const ctx = global.ensureServerCtx(conn)
    const projects = ctx.projects.list()
    return ctx.projects.last() ?? projects[0]?.worktree
  }
}
